<template>
  <multi-picker
      :active="active"
      :children="roomGroups"
      :title="label"
      :is-active="isActive"
      :icon="'/static/img/location-light.svg'"
      :close-on-click="false"
      @click-child="(item) => toggle(item.id)"
  />
</template>

<script>
import {mapState} from "vuex";
import MultiPicker from "../parts/multi-picker";

export default {
  name: "search-filter-group",
  components: {MultiPicker},
  computed: {
    roomGroups() {
      return this.$store.getters["search/roomGroups"].map((item) => {
        return {
          id: item.id,
          label: item.text.name
        }
      });
    },
    active () {
      return this.roomGroups.length > 1;
    },
    ...mapState({
      currentValue: s => s.search.search.group
    }),
    label() {
      if (this.currentValue === null || this.currentValue.length === 0)
        return 'Quartiers';
      if (this.currentValue.length === 1)
        return '1 Quartier';
      return this.currentValue.length + ' Quartiers';
    }
  },
  methods: {
    isActive (item) {
      const value = this.currentValue ? this.currentValue : [];
      return value.indexOf(item.id) !== -1;
    },
    toggle(id) {
      const value = this.currentValue ? this.currentValue : [];
      if (value.indexOf(id) !== -1) {
        value.splice(value.indexOf(id), 1);
        this.$store.commit('search/SET_SEARCH_GROUP', value.length === 0 ? null : value);
        return;
      }
      value.push(id);
      this.$store.commit('search/SET_SEARCH_GROUP', value);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/search/picker/search-filter-group.vue